module.exports = __webpack_public_path__ + "static/img/001_TO8_1498_og.00da4c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/001_TO8_1498_og.jpg
// module id = z1yK
// module chunks = 0